import * as cx from 'classnames'
import get from 'lodash-es/get'
import * as React from 'react'

import { IItemCard } from '../interface'

import ui from '../../../../common/constants/ui'
import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import TrendingSash from '../../../components/trendingSash'
import FeatureContainer from '../../../containers/feature/featureContainer'

import ItemCardContentCommonWrapper from '../itemCardContentCommonWrapper'
import ItemCardSidebar from '../itemCardSidebar'
import LockupAddToCartButton from '../lockupAddToCartButton'
import LockupAttributes from '../lockupAttributes'
import Features from '../lockupFeatures'
import LockupFilesIncluded from '../lockupFilesIncluded'
import LockupKeyFeatures from '../lockupKeyFeatures'
import Preview from '../lockupPreview'
import LockupPreviewActionPanel from '../lockupPreviewActionPanel'
import LockupPreviewButton from '../lockupPreviewButton'
import Tags from '../lockupTags'
import LockupTagsOnMobile from '../lockupTagsOnMobile'

import * as styles from './narrowItemCard.module.css'

interface IState {
  collapsed: boolean
}

class NarrowItemCard extends React.Component<IItemCard, IState> {
  public render() {
    const { item, rank, onItemLinkClick, viewType } = this.props
    const { tags = '', term = '' } = this.props.locationParams

    const rootClass = cx(styles.root, {
      [styles.listView]: viewType === 'list',
      [styles.gridView]: viewType !== 'list'
    })

    return (
      <div className={rootClass}>
        <article className={styles.card}>
          <section className={styles.preview}>
            {item.trending && <TrendingSash lazy large />}
            <Preview
              item={item}
              rank={rank}
              onItemLinkClick={onItemLinkClick}
            />
            <div className={cx(styles.previewTags)}>
              <Tags item={item} tags={tags} term={term} />
            </div>

            <section className={cx(styles.previewActionPanel, styles.hidden)}>
              <a
                href={`${item.url}?s_rank=${rank}`}
                onClick={onItemLinkClick}
                className={styles.previewActionPanelClickHandler}
                role="toolbar"
                title={item.name}
              />
              <section className={styles.previewActionPanelActions}>
                <LockupPreviewActionPanel {...this.props} />
              </section>
            </section>
          </section>
          <section className={styles.content}>
            <ItemCardContentCommonWrapper {...this.props}>
              <FeatureContainer name="metaInfo:showKeyFeatures">
                <LockupKeyFeatures {...this.props} term={term} />
              </FeatureContainer>
              <FeatureContainer name="metaInfo:showAttributes">
                <LockupAttributes {...this.props} />
                <LockupFilesIncluded {...this.props} />
              </FeatureContainer>
              <LockupTagsOnMobile {...this.props} tags={tags} term={term} />
            </ItemCardContentCommonWrapper>
          </section>
          <section className={styles.sidebar}>
            <ItemCardSidebar {...this.props} />
          </section>
        </article>
      </div>
    )
  }
}

export default NarrowItemCard
